function geocoding(requestObj) {
    var geocoder = new window.google.maps.Geocoder();

    return new Promise((resolve, reject) => {
        geocoder.geocode(requestObj, (results, status) => {
            if (status === window.google.maps.GeocoderStatus.OK) {
                resolve(results);
            } else {
                reject(status);
            }
        });
    });
}

module.exports = {
    geocoding: geocoding,
};
